var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"expand"}},[(_vm.display)?_c('div',{staticClass:"outer"},[_c('div',{class:_vm.innerClass},[_c('div',{staticClass:"notification",class:_vm.notificationClass},[_vm._v(_vm._s(_vm.text))])])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }